import React, { useEffect } from "react";
import { connect } from "react-redux";
import { ssoSignOut } from "../../actions/AuthActions";
import { Dropdown, Row, Col } from "react-bootstrap";
import { getSchoolLogoForLogin } from "../../actions/SchoolActions";
import { awaitableRootSchoolCode } from "../../apis/ApiConfig";
import ScreenReaderNavigator, { TabStopAnchor } from "../Menus/ScreenReaderNavigator";

const LoginHeader = ({ user, global, school, isSignedIn, getSchoolLogoForLogin, ssoSignOut, match }) => {
  useEffect(() => {
    async function fetchData() {
      var schoolCode;
      if (!isSignedIn) {
        schoolCode = await awaitableRootSchoolCode();
      } else {
        schoolCode = school.schoolCode;
      }

      getSchoolLogoForLogin(
        schoolCode
      );
    }
    fetchData();
  }, [global.aidYear, school.schoolCode, getSchoolLogoForLogin, isSignedIn]);


  return (
    <div className={"border-bottom"}>
      <ScreenReaderNavigator />
      <Row>
        <Col>
          <h1 className="mb-2" style={{ float: "left" }}>
            VERIFICATION GATEWAY
          </h1>
        </Col>
        <Col>
          <img
            src={`data:image/jpeg;base64,${school.schoolLogo}`}
            alt={school.schoolName + "_logo"}
          ></img>
        </Col>
      </Row>

      {isSignedIn && (
        <>
          <Row>
            <Col></Col>
            <Col>
              <Dropdown
                alignRight
                className="menuIcon inline"
                style={{ float: "right" }}
              >
                <Dropdown.Toggle as="i" id="dropdown-basic">
                  <TabStopAnchor style={{ color: "unset" }}>
                    <i className="fas fa-user badgeIcon" />
                  </TabStopAnchor>
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <>
                      <p className="ml-2">Logged On as:</p>
                      <p className="ml-2">
                        <strong>{user?.fullName}</strong>
                      </p>
                    </>
                  <Dropdown.Item onClick={() => ssoSignOut()}>
                    Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Col>
          </Row>
        </>
      )}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.auth.user,
    global: state.global,
    school: state.school,
    isSignedIn: state.auth.isSignedIn
  };
};

export default connect(mapStateToProps, { ssoSignOut, getSchoolLogoForLogin })(
  LoginHeader
);
